const BLOG_CATEGORY_LOADING = "BLOG_CATEGORY_LOADING";
const BLOG_CATEGORY_ERROR = "BLOG_CATEGORY_ERROR";
const BLOG_CATEGORY_SUCCESS = "BLOG_CATEGORY_SUCCESS";

export { BLOG_CATEGORY_LOADING, BLOG_CATEGORY_ERROR, BLOG_CATEGORY_SUCCESS };